import moment from 'moment'

export const getOrderDate = (date) => {
  return moment(date).format('DD/MM/YYYY, HH:mm')
}

export const getBookingDateTime = (date) => {
  return moment(date)
    .set({ second: 0 })
    .format('YYYY-MM-DD HH:mm:ss')
}

export const getDayNameBookingViewModal = (date) => {
  return moment(date).format('ddd')
}

export const getDateBookingViewModal = (date) => {
  return moment(date).format('DD')
}

export const getIssueReportDate = (date, language) => {
  return moment(date).locale(language.toLowerCase()).format('DD MMM YYYY . HH:MM')
}
